import pl0 from "../components/exampleData/pathways_list.json";

import useSWRImmutable from "swr/immutable";
import { relativeURL } from "../relativeURL";

const fetcher = (url) => fetch(url).then((res) => res.json());

export function useSearch(text, species) {
  const { data, error } = useSWRImmutable(
    () => (text !== "" ? relativeURL(`/api/search/${text}/${species}`) : null),
    fetcher
  );

  if (text === "") {
    return {
      dataRetrieved: pl0, // randomPathList[Math.floor(Math.random() * 5)],
      isLoadingSearch: false,
      isError: false,
    };
  }

  return {
    dataRetrieved: data,
    isLoadingSearch: !error && !data,
    isError: error,
  };
}
